module.exports = __webpack_public_path__ + "assets/img/dailyTask-bottom-right-right.177e7fdc.png";